import { render } from "./HelpFunctionalityList.vue?vue&type=template&id=63e0731e&scoped=true&ts=true"
import script from "./HelpFunctionalityList.vue?vue&type=script&lang=ts"
export * from "./HelpFunctionalityList.vue?vue&type=script&lang=ts"

import "./HelpFunctionalityList.vue?vue&type=style&index=0&id=63e0731e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e0731e"]])

export default __exports__